// replaces any non-alphanumeric characters with empty string
export default (string, space) =>
  space ? string.replace(/[^a-zA-Z ]/gi, '') : string.replace(/[^a-zA-Z]/gi, '')
